import Head from "next/head";

import MainLayout from "src/layouts/mainLayout";
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"
import Content from "src/components/pages/wallet/Content";

const Wallet = () => {
    return (
        <>
            <Head>
                <title>کیف پول</title>
            </Head>
            <Content />
        </>
    );
};
Wallet.Layout = MainLayout;
export default Wallet;

export async function getServerSideProps(context) {
    return {
        props: {
            isSsrMobile: getIsSsrMobile(context)
        }
    }
}
